export class InlineFramePage {
  index: number = -1;
  id: string = '';
  available: boolean = true;
  label: string = '';
  url: string = '';
  machineTab: boolean = false;

  constructor(id: string, label: string, machineTab: boolean, url: string) {
    this.id = id;
    this.label = label;
    this.machineTab = machineTab;
    this.url = url;
  }
}
